import ReportFilterDateRangeDropdown from "@/reports/components/ReportFilterDateRangeDropdown";
import useAdminReportingFiltersContext from "@/reports/admin/useAdminReportingFiltersContext";

interface DateRangeFilterProps {
  isClassroomReportPage: boolean;
}

const DateRangeFilter = (props: DateRangeFilterProps) => {
  const { dateRangeMenuOptions, dateRangeFilterDefaultOption } =
    useAdminReportingFiltersContext();
  const { isClassroomReportPage } = props;
  const eventTrackingDescription = `Teacher Reporting - ${isClassroomReportPage ? "classroom" : "student"} date filter`;

  return (
    <ReportFilterDateRangeDropdown
      menuOptions={dateRangeMenuOptions}
      defaultOption={dateRangeFilterDefaultOption}
      label="Date range"
      urlSearchParam="date_range"
      eventTrackingDescription={eventTrackingDescription}
      allowCustomDateRange
    />
  );
};

export default DateRangeFilter;
